import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";

const ListBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [totalBlogs, setTotalBlogs] = useState(0);
    const blogsPerPage = 20;
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const page = Math.min(Math.max(Number(searchParams.get("page")), 1), Math.ceil(totalBlogs / blogsPerPage)) || 1;

    const fetchBlogs = async (currentPage) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/list/${currentPage}`);
            setBlogs(response.data);
        } catch (error) {
            console.error("Error fetching blogs:", error);
        }
    };

    const fetchBlogCount = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/count`);
            setTotalBlogs(response.data.count);
        } catch (error) {
            console.error("Error fetching blog count:", error);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchBlogs(page);
    }, [page]);

    useEffect(() => {
        fetchBlogCount();
    }, []);

    const updatePage = (newPage) => {
        setSearchParams({ page: newPage });
    };

    return (
        <>
            <Helmet>
                <title>Bloglar - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}?page=${page}`} />
                <meta name="description" content="Hukuka dair bilgilendirici bloglar ve yazılar." />
            </Helmet>
            <Header />
            <section className="bg-custom-gray py-5">
                <div className="container shadow-sm p-4 bg-white">
                    <ol className="breadcrumbnav">
                        <li><Link to="/">Ana Sayfa</Link></li>
                        <li>Bloglar</li>
                    </ol>
                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-md-10 mx-auto">
                                <div className="card">
                                    <div className="card-header bg-orange text-white">
                                        <h4 className="mb-0">Sitemizdeki Mevcut Blog Yazıları</h4>
                                    </div>
                                    <ul className="list-group list-group-flush">
                                        {blogs.map((blog) => (
                                            <li
                                                key={blog.id}
                                                className="list-group-item d-flex blog-list align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => navigate(`/blog/${blog.slug}`)}
                                            >
                                                <div className="blog-image-cover mr-4">
                                                    <img src={blog.preview_img_src} alt={blog.title} className="blog-image" loading="lazy" />
                                                </div>
                                                <h5 className="mb-1 d-inline">{blog.title}</h5>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Sayfalandırma */}
                    <div className="d-flex justify-content-center my-4">
                        <div className="card border-0">
                            <div className="card-body d-flex align-items-center">
                                <button
                                    onClick={() => updatePage(page - 1)}
                                    disabled={page === 1}
                                    className="btn btn-outline-primary btn-sm d-flex align-items-center me-3"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="me-1"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                        />
                                    </svg>
                                    Önceki
                                </button>

                                <span className="text-muted fs-6">
                                    Sayfa {page} / {Math.ceil(totalBlogs / blogsPerPage)}
                                </span>

                                <button
                                    onClick={() => updatePage(page + 1)}
                                    disabled={page === Math.ceil(totalBlogs / blogsPerPage)}
                                    className="btn btn-outline-primary btn-sm d-flex align-items-center ms-3"
                                >
                                    Sonraki
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-arrow-right-circle ms-1"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer showSSS={true} />
        </>
    );
};

export default React.memo(ListBlogs);
